import FundingSourceTable from "./FundingSourceTable";

export default FundingSourceTable;
